<template>
  <div class="price-box price-box_with-old-price">
    <div
        :class="['', old_price.value != 0 ? 'price-box__old':'price-box__current']">
      {{ price.name }}
    </div>
    <div v-if="old_price.value != 0"
         class="price-box__current">{{ old_price.name }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductPrice",
  props: {
    price: {},
    old_price: {},
  },
}
</script>

<style scoped>

</style>